import { module } from 'angular';
import templateBuilderCurrencyData from './builder/data.html';
import templateBuilderCurrencyDisplay from './builder/display.html';
import templateBuilderCurrencyValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/currency/data.html', templateBuilderCurrencyData);
	$templateCache.put('kform/components/currency/display.html', templateBuilderCurrencyDisplay);
	$templateCache.put('kform/components/currency/validate.html', templateBuilderCurrencyValidate);
});
